module.exports = __webpack_public_path__ + "static/browse2-39cd556a9d205ba53e7519d68d03c7be.png";